import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify.js'
import './registerServiceWorker'
import {mainAuth} from '@/FirebaseConfig.js' //inizialezedapp main

Vue.config.productionTip = false


Vue.filter('number', (value) => {
  if (!value) return ''
  return Number(Number(value).toFixed(2)) 
})
Vue.filter('isset', (value) =>  (!value) ? '' : value )
Vue.filter('toUppercase', (value) => {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
})
Vue.mixin({
  methods: {
    toNumber: (value) => Number(Number(value).toFixed(2)) ,
    obtener_llave: (arreglo, llave_de_comparacion, comparacion, llave_de_respuesta ) =>{
      let data = arreglo.filter(item => item[llave_de_comparacion] == comparacion)
      if(data.length>0) return data[0][llave_de_respuesta]
    },
    obtener_color_de_estado: (value) => {
      switch (value) {
        case 'esperando':
          return 'secondary'
          break
        case 'procesando':
          return 'secondary'
          break
        case 'procesado':
          return 'primary'
          break
        case 'emitido':
          return 'secondary'
          break
        case 'anulado':
          return 'secondary'
          break
      }
    },
    obtener_icono_de_estado: (value) => {
      switch (value) {
        case 'esperando':
          return 'fas fa-check'
          break
        case 'procesando':
          return 'fas fa-circle-notch fa-spin'
          break
        case 'procesado':
          return 'fas fa-check-double'
          break
        case 'emitido':
          return 'fas fa-check'
          break
        case 'anulado':
          return 'fas fa-times'
          break
      }
    }

  }
})


let app=''
mainAuth.onAuthStateChanged(()=>{
  if(!app){
    app=new Vue({
      router,
      vuetify,
      store,
      render:h => h(App)
    }).$mount('#app')
  }
})